import { useSelector } from 'react-redux';
import { FLOPFLIP_STATE_SLICE } from '@flopflip/react-redux';
import flagNames from '../../store/featureFlags';
import defaultFeatureFlags from '../../store/defaultFeatureFlags';

const useChatbotProvider = () => useSelector(state => {
  const flags = state[FLOPFLIP_STATE_SLICE]?.flags;
  const isEnabled = name => (
    flags?.memory?.[name] ?? flags?.[name] ?? defaultFeatureFlags[name]
  ) === true;

  if (isEnabled(flagNames.LEX_BOT_ENABLED)) return 'lex';
  if (isEnabled(flagNames.SUPER_PHOEBE_ENABLED)) return 'super-phoebe';
  return 'none';
});

export default useChatbotProvider;
